import React from "react"
import ImageUpload from "components/ReactHookForm/ImageUpload"
import ImageUploadComponent from "components/ImageUploadComponent"
import CheckeredFrame from "components/elements/CheckeredFrame"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import extendFormValuesWithImages from "utilities/extendFormValuesWithImages"
import type { DioboxEvent } from "sharedTypes"

const KioskLogoUploadComponent = (props: React.ComponentProps<typeof ImageUploadComponent>) => {
  const { imagePreview, ...rest } = props

  return (
    <ImageUploadComponent
      {...rest}
      uploadButtonText="Upload Logo"
      imagePreview={imagePreview && (
        <CheckeredFrame>{imagePreview}</CheckeredFrame>
      )}
    />
  )
}

type Props = {
  isOpen: boolean
  onClose: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const KioskBrandLogoModal = ({
  isOpen,
  onClose,
  event,
  updateEvent,
}: Props) => {
  if (!isOpen) {
    return null
  }

  return (
    <ModalForm
      title="Brand Logo"
      size="xl"
      onClose={onClose}
      initialValues={{
        kioskLogoUrl: event.kioskLogoUrl ?? undefined,
        ...extendFormValuesWithImages({}, ["kioskLogo"]),
      }}
      onSubmit={async (v) => {
        await updateEvent({
          kioskLogo: v.kioskLogo,
          kioskLogoUrl: v.kioskLogoUrl,
        })
        onClose()
      }}
      disableSubmitWhenNotDirty
    >
      {({ control }) => (
        <ImageUpload
          name="kioskLogo"
          control={control}
          description="Upload a logo that will be displayed consistently across all Kiosk Mode screens. For best results, use a transparent PNG in white or light colors, as the background is automatically darkened to improve visibility."
          imageWidth="auto"
          imageHeight="auto"
          imageMaxWidth={32}
          imageMaxHeight={32}
          imageFit="contain"
          hideImageBorder
          imageUrl={event.kioskLogoUrl || ""}
          Component={KioskLogoUploadComponent}
          helperText="Supports PNG and JPG formats, up to 5 MB."
          vertical
          labelSize="lg"
          labelWeight="semibold"
        />
      )}
    </ModalForm>
  )
}

export default KioskBrandLogoModal
